import React, { useState, useGlobal } from "reactn";
import "./RequestInfo.css";
import { withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import { ModalTemplate } from "../UI/modalComponents";
import BaseModal from "./baseModal/BaseModal";
import { BLUE_BUTTON, RED_BUTTON } from "./baseModal/colours";
import { STRING_INPUT, TITLE } from "./baseModal/FieldTypes";

/**
 * Modal can be used as an waitlist confirmation modal.
 *
 * @callback onSubmit Function executed upon user confirmation
 * @callback onClose Function executed when modal is closed.
 *
 * @param {Boolean} toArchive true means archival, false means unarchival.
 * @param {Boolean} confirmHeader Optional custom modal header.
 * @param {String | JSX} modalBody Optional custom modal body.
 */

const WaitlistAcceptModal = ({
  onSubmit,
  onClose,
  onManual,
  totalSpots,
  currentSpots,
  waitlistedSpots,
  pendingSpots,
  applicationRequired
}) => {
  const [loading, setLoading] = useGlobal("loading");
  const availableSpots = totalSpots - currentSpots - pendingSpots;
  let spotsToAccept = -1;
  // if (!applicationRequired) {
  if (waitlistedSpots <= availableSpots) {
    spotsToAccept = waitlistedSpots;
  } else {
    spotsToAccept = availableSpots;
  }
  // }

  const handleAutomaticAccept = async e => {
    if (e && e.preventDefault) e.preventDefault();
    setLoading(true);
    try {
      await onSubmit();
      // toast.success("Successfully accepted waitlisted users");
    } catch (err) {
      // toast.error("Error occurred while accepting waitlisted users");
    } finally {
      onClose();
      setLoading(false);
    }
  };

  const handleManualAccept = async e => {
    if (e && e.preventDefault) e.preventDefault();
    try {
      await onManual();
    } catch (err) {
      console.error(err);
    } finally {
      onClose();
    }
  };

  const getWaitlistAcceptModalFields = () => {
    const titleField = {
      type: TITLE,
      data: {
        name: "Confirm Waitlist Acceptance"
      }
    };

    const fields = [];

    const noApplicationRequiredField = {
      type: TITLE,
      data: {
        name: `There are currently ${waitlistedSpots} pending applications on this listing 
          and ${availableSpots} available spots. 
          Would you like to automatically accept the first ${spotsToAccept} pending applications or manually review them?`
      }
    };
    const noApplicationRequiredNote = {
      type: TITLE,
      data: {
        name: `Note: For listing with multiple payment plans, the waitlisted users will be accepted to the payment plan they selected at checkout `
      }
    };
    fields.push(noApplicationRequiredField);
    fields.push(noApplicationRequiredNote);

    return fields;
  };

  const getWaitlistAcceptModalButtons = () => {
    const acceptButton = {
      name: "Automatically Accept",
      buttonColour: BLUE_BUTTON,
      textColour: "#fff",
      isDisabled: false,
      handleClick: handleAutomaticAccept
    };
    const rejectButton = {
      name: "Manually Review",
      buttonColour: RED_BUTTON,
      textColour: "#fff",
      isDisabled: false,
      handleClick: handleManualAccept
    };
    return [acceptButton, rejectButton];
  };

  const getWaitlistAcceptModalProps = () => {
    return {
      title: "Confirm Waitlist Acceptance",
      fields: getWaitlistAcceptModalFields(),
      buttons: getWaitlistAcceptModalButtons(),
      height: "65vh",
      midSectionHeight: "52vh",
      handleClose: onClose
    };
  };

  return <BaseModal {...getWaitlistAcceptModalProps()} />;
};

export default withRouter(WaitlistAcceptModal);
